import React from 'react';
import {
  Box,
  Flex,
  Textarea,
  IconButton,
  useColorModeValue,
  Text
} from '@chakra-ui/react';
import { FaPaperPlane } from 'react-icons/fa';

/**
 * Component for WhatsApp message input and send button
 */
const ChatInput = ({ 
  message, 
  setMessage, 
  handleSendMessage, 
  isSending, 
  borderColor,
  senderName
}) => {
  const inputBgColor = useColorModeValue('white', 'gray.700');
  const inputTextColor = useColorModeValue('black', 'white');

  return (
    <Box 
      borderTopWidth="1px" 
      borderColor={borderColor} 
      p={3}
    >
      <Flex>
        <Textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type a message"
          size="sm"
          resize="none"
          bg={inputBgColor}
          color={inputTextColor}
          borderRadius="md"
          rows={2}
          minH="unset"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              // Use void to ensure we don't return anything from this handler
              void handleSendMessage();
            }
          }}
          aria-label="Type a message"
        />
        <IconButton
          icon={<FaPaperPlane size={18} />}
          aria-label="Send message"
          ml={2}
          colorScheme="green"
          bg="#25D366" // WhatsApp green color
          color="white"
          size="md"
          isLoading={isSending}
          onClick={() => void handleSendMessage()}
          alignSelf="flex-end"
          isDisabled={!message.trim()}
          _hover={{ bg: '#128C7E' }} // Darker WhatsApp green on hover
        />
      </Flex>
      {senderName && (
        <Text fontSize="xs" color="gray.500" mt={1} textAlign="right">
          Sending as: {senderName}
        </Text>
      )}
    </Box>
  );
};

export default ChatInput;
